import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DateSelect from "../Components/DateSelect";
import Chart from "../Components/TemperatureChart";
import Title from "../Components/Title";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import {
  formatChartData,
  formatTimeWithTZOffset,
  getTimestampWithoutOffset,
  getToken,
  validateDateType,
} from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import { useStyles } from "../Utils/Styles";

const server = EnvSettings.server;

function ChartContainer({
  currentDevices,
  data,
  chartCopies,
  setChartCopies,
  id,
  lines,
  setLines,
}) {
  const classes = useStyles();

  return (
    <Grid item md={currentDevices.length > 1 ? 6 : 12} sm={12}>
      <Paper className={classes.paper} style={{ height: 400 }}>
        <Chart
          data={{
            chartData: formatChartData(data.Measurements),
            title: data.deviceName || data.serialNumber,
            deviceConfig: data.DeviceConfig,
            deviceType: data.deviceType,
            id: id,
            lines: lines,
            setLines: setLines,
            setChartCopies: setChartCopies,
            chartCopies: chartCopies,
            copyData: data,
          }}
        />
      </Paper>
    </Grid>
  );
}

export default function Monitoring(props) {
  const classes = useStyles();
  const [currentDevices, setDevices] = useState(undefined);
  const { t } = useTranslation();
  const today = formatTimeWithTZOffset(new Date().toISOString()).substr(0, 10);
  const [oneDate, setOneDate] = useState(true);
  var d = props.computedMatch.params.select_date || today;
  const [selectedDate, setDate] = useState(d);
  const [rangeStartTime, setRangeStartTime] = useState();
  const [rangeEndDate, setRangeEndDate] = useState();
  const [rangeEndTime, setRangeEndTime] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  const [chartCopies, setChartCopies] = useState();
  const [lines, setLines] = useState();
  const [loading, setLoading] = useState(false);
  // const [inter, setInter] = useState();

  let getChartData = (p) => {
    var stime;
    var etime;
    setLoading(true);
    if (p) {
      stime = getTimestampWithoutOffset(today + " 00:00:00");
      etime = getTimestampWithoutOffset(today + " 23:59:59");
    } else {
      if (
        validateDateType(selectedDate, "date") &&
        validateDateType(rangeStartTime, "time") &&
        validateDateType(rangeEndDate, "date") &&
        validateDateType(rangeEndTime, "time")
      ) {
        stime = getTimestampWithoutOffset(
          selectedDate + " " + rangeStartTime + ":00"
        );
        etime = getTimestampWithoutOffset(
          rangeEndDate + " " + rangeEndTime + ":59"
        );
      } else if (
        validateDateType(selectedDate, "date") &&
        validateDateType(rangeEndDate, "date")
      ) {
        stime = getTimestampWithoutOffset(selectedDate + " 00:00:00");
        etime = getTimestampWithoutOffset(rangeEndDate + " 23:59:59");
      } else {
        stime = getTimestampWithoutOffset(selectedDate + " 00:00:00");
        etime = getTimestampWithoutOffset(selectedDate + " 23:59:59");
      }
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        time_period_start: stime,
        time_period_end: etime,
      }),
    };
    fetch(server + "/get_continuous_data", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          if (result.message === "No records found") {
            setDevices(undefined);
          } else {
            dispatch(showPopupSnackbar(result));
          }
        } else {
          setDevices(undefined);
          setDevices(result.devices);
          //setData(result.transport)
        }
        setLoading(false);
      });
  };
  /*
  let refresh = () => {
    setInter(
      setInterval(function () {
        getChartData(true);
      }, 60000)
    );
  };

  useEffect(() => {
    if (!currentDevices) {
      refresh();
    }
    return () => {
      clearInterval(inter);
    };
  }, [inter, currentDevices]);

  useEffect(() => {
    if (!oneDate) {
      clearInterval(inter);
    }
  }, [oneDate, inter]); */

  useEffect(getChartData, [
    /*rangeEndDate,
    rangeEndTime,
    rangeStartTime,
    selectedDate, */
  ]);

  const handleSubmit = () => {
    getChartData();
  };

  /*useEffect(() => {
    getChartData();
  }, [rangeEndTime]); */

  let handleDate = (e) => {
    if (validateDateType(e.target.value, "date")) {
      if (e.target.value !== today) {
        setDate(e.target.value);
        // clearInterval(inter);
      } else {
        setDate(today);
        // refresh();
      }
    }
  };

  let checkCopies = (id) => {
    if (chartCopies && chartCopies[id]) {
      return true;
    }
    return false;
  };

  let handlePdf = () => {
    if (process.env.NODE_ENV !== "production") {
      console.log(currentDevices);
    }
    if (!currentDevices || currentDevices.length === 0) {
      return;
    }
    var x = false;
    currentDevices.forEach((dev) => {
      if (dev.Measurements.length) {
        x = true;
      }
    });
    if (!x) {
      return;
    }
    var dates =
      selectedDate +
      " " +
      (rangeStartTime || "00:00") +
      ":00/" +
      (rangeEndDate || selectedDate) +
      " " +
      (rangeEndTime || "23:59") +
      ":59";
    history.push("/report/continuous/" + dates);
  };

  return (
    <Grid container spacing={3}>
      <DateSelect
        handlePdf={handlePdf}
        handleSubmit={handleSubmit}
        handleDate={handleDate}
        oneDate={oneDate}
        setOneDate={setOneDate}
        selectedDate={selectedDate}
        setDate={setDate}
        rangeStartTime={rangeStartTime}
        setRangeStartTime={setRangeStartTime}
        rangeEndDate={rangeEndDate}
        setRangeEndDate={setRangeEndDate}
        rangeEndTime={rangeEndTime}
        setRangeEndTime={setRangeEndTime}
        activityIndicator={loading}
      />
      {currentDevices
        ? currentDevices.map((row, idx) =>
            row.Measurements.length > 0 ? (
              <React.Fragment>
                <ChartContainer
                  data={row}
                  setChartCopies={setChartCopies}
                  chartCopies={chartCopies}
                  currentDevices={currentDevices}
                  id={idx}
                  lines={lines}
                  setLines={setLines}
                />
                {checkCopies(row.id) ? (
                  <ChartContainer
                    data={row}
                    setChartCopies={setChartCopies}
                    chartCopies={chartCopies}
                    currentDevices={currentDevices}
                    id={`${idx}n`}
                    lines={lines}
                    setLines={setLines}
                  />
                ) : undefined}
              </React.Fragment>
            ) : (
              <Grid item xs={currentDevices.length > 1 ? 6 : 12}>
                <Paper className={classes.paper}>
                  <Title>{row.deviceName || row.serialNumber}</Title>
                  <Title>{t("monitoring.noData")}</Title>
                </Paper>
              </Grid>
            )
          )
        : undefined}
    </Grid>
  );
}
